import { useState } from 'react'
import type { CompetitionConfig } from '@/lib/competitions'

interface CompetitionCardProps {
  competition: CompetitionConfig
  isSelected: boolean
  onClick: () => void
}

export function CompetitionCard({ competition, isSelected, onClick }: CompetitionCardProps) {
  const [logoFailed, setLogoFailed] = useState(false)

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center gap-3 p-3 rounded-lg border-2 transition-all text-left w-full
        ${isSelected
          ? 'border-emerald-500 bg-emerald-50 dark:bg-emerald-950 dark:border-emerald-400'
          : 'border-zinc-200 dark:border-zinc-700 hover:border-zinc-300 dark:hover:border-zinc-600 bg-white dark:bg-zinc-900'
        }`}
    >
      {competition.logo && !logoFailed ? (
        <img
          src={competition.logo}
          alt=""
          className="w-7 h-7 object-contain shrink-0"
          onError={() => setLogoFailed(true)}
        />
      ) : (
        <span className="text-2xl shrink-0">{competition.flag}</span>
      )}
      <div className="min-w-0">
        <p className={`font-medium text-sm truncate ${isSelected ? 'text-emerald-700 dark:text-emerald-300' : 'text-zinc-800 dark:text-zinc-200'}`}>
          {competition.name}
        </p>
        <p className="text-xs text-zinc-500 dark:text-zinc-400">{competition.country}</p>
      </div>
    </button>
  )
}
